/** The operator's flows, as `GET operators/me/` names them in `warehouses[].flows`. */
export const OPERATOR_FLOW = {
  RECEIVING: 'receiving',
  PUTAWAY: 'putaway',
  PICKING: 'picking',
  PACKING: 'packing',
  DISPATCH: 'dispatch',
  KITS: 'kits',
  STOCK: 'stock',
};

/** The order the floor works in, which is the order Inicio shows them in. */
export const OPERATOR_FLOW_ORDER = [
  OPERATOR_FLOW.RECEIVING,
  OPERATOR_FLOW.PUTAWAY,
  OPERATOR_FLOW.PICKING,
  OPERATOR_FLOW.PACKING,
  OPERATOR_FLOW.DISPATCH,
  OPERATOR_FLOW.KITS,
  OPERATOR_FLOW.STOCK,
];

/**
 * Flows the floor hides for now, though the backend serves them: their card and
 * their name in the warehouse list go, their route and API stay. Take one out
 * to show it again.
 */
export const OPERATOR_HIDDEN_FLOWS = [OPERATOR_FLOW.KITS];

export const OPERATOR_FLOW_LABELS = {
  [OPERATOR_FLOW.RECEIVING]: 'Recepción',
  [OPERATOR_FLOW.PUTAWAY]: 'Almacenado',
  [OPERATOR_FLOW.PICKING]: 'Picking',
  [OPERATOR_FLOW.PACKING]: 'Empaque',
  [OPERATOR_FLOW.DISPATCH]: 'Despacho',
  [OPERATOR_FLOW.KITS]: 'Kits',
  [OPERATOR_FLOW.STOCK]: 'Consulta',
};

/** The flows whose queues make tasks for the tray; Kits and Consulta make none. */
export const OPERATOR_TASK_FLOWS = [
  OPERATOR_FLOW.RECEIVING,
  OPERATOR_FLOW.PUTAWAY,
  OPERATOR_FLOW.PICKING,
  OPERATOR_FLOW.PACKING,
  OPERATOR_FLOW.DISPATCH,
];

/** Inicio's tabs. The phone remembers the last one chosen (`prefs.homeTab`). */
export const HOME_TAB = {
  TASKS: 'tasks',
  FREE: 'free',
};

export const HOME_TAB_LABELS = {
  [HOME_TAB.TASKS]: 'Tareas',
  [HOME_TAB.FREE]: 'Trabajo libre',
};

/**
 * What a backend says it can do beyond the base (`me.capabilities`). A screen
 * that needs one stays hidden until the backend that serves it is deployed.
 */
export const OPERATOR_CAPABILITY = {
  PICKING_ROUTE: 'picking_route',
  /** Reserving an order's stock from the picking walk. */
  ORDER_RESERVE: 'order_reserve',
  /** Sending a packed order to its courier from packing. */
  COURIER_SEND: 'courier_send',
  /** Creating the shipment again from packing once the items of a labeled order changed. */
  COURIER_RELABEL: 'courier_relabel',
};

/** The workspace's screens that are not a flow, as `taskEntered` names them. */
export const OPERATOR_SCREEN = {
  HOME: 'home',
  FLOW_UNAVAILABLE: 'flow-unavailable',
  NOT_FOUND: 'not-found',
};

export const OPERATOR_FLOW_PATHS = {
  [OPERATOR_FLOW.RECEIVING]: '/receiving',
  [OPERATOR_FLOW.PUTAWAY]: '/putaway',
  [OPERATOR_FLOW.PICKING]: '/picking',
  [OPERATOR_FLOW.PACKING]: '/packing',
  [OPERATOR_FLOW.DISPATCH]: '/dispatch',
  [OPERATOR_FLOW.KITS]: '/kits',
  [OPERATOR_FLOW.STOCK]: '/lookup',
};

/** Where the operator's warehouses come from. */
export const WAREHOUSES_SOURCE = {
  ASSIGNED: 'assigned',
  /** None assigned: the operator works on its employing admin's. */
  ADMIN_FALLBACK: 'admin_fallback',
  NONE: 'none',
};

/** The one module reason the rest of the WMS screens never see. */
export const FLOW_DISABLED_REASON = 'flow_disabled';

export const FLOW_DISABLED_LABEL = 'tu rol no tiene este flujo, o la bodega no lo tiene encendido';

/** What Consulta asks the scan to recognise: everything. Orders only come where picking, packing or dispatch is open. */
export const LOOKUP_KINDS = ['slot', 'product', 'receipt', 'supply', 'order'];

/** Where a scanned order goes now, as the scan names it in `next_flow`. */
export const ORDER_FLOW_LABELS = {
  [OPERATOR_FLOW.PICKING]: OPERATOR_FLOW_LABELS[OPERATOR_FLOW.PICKING],
  [OPERATOR_FLOW.PACKING]: OPERATOR_FLOW_LABELS[OPERATOR_FLOW.PACKING],
  [OPERATOR_FLOW.DISPATCH]: OPERATOR_FLOW_LABELS[OPERATOR_FLOW.DISPATCH],
};

export const LOOKUP_HISTORY_SIZE = 10;
